import { render } from "./LotsCompletedPurchasesPage.vue?vue&type=template&id=fdfe0c28&scoped=true"
import script from "./LotsCompletedPurchasesPage.vue?vue&type=script&lang=js"
export * from "./LotsCompletedPurchasesPage.vue?vue&type=script&lang=js"

import "./LotsCompletedPurchasesPage.vue?vue&type=style&index=0&id=fdfe0c28&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdfe0c28"]])

export default __exports__